import React from 'react';

export default function FormConfirmed() {
  const error = new URLSearchParams(window.location.search).get('error');
  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f5f5f7', padding: 20, fontFamily: "-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,Arial,sans-serif" }}>
      <div style={{ width: '100%', maxWidth: 440, background: '#fff', borderRadius: 16, boxShadow: '0 4px 24px rgba(0,0,0,0.06)', padding: 40, textAlign: 'center' }}>
        <div style={{ fontSize: 44, marginBottom: 12 }}>{error ? '⚠️' : '🎉'}</div>
        <h2 style={{ margin: '0 0 8px', color: '#111' }}>
          {error ? 'Link expired or invalid' : "You're subscribed!"}
        </h2>
        <p style={{ color: '#666', lineHeight: 1.6, margin: 0 }}>
          {error
            ? 'This confirmation link is no longer valid. Please sign up again.'
            : 'Thanks for confirming — your subscription is now active.'}
        </p>
      </div>
    </div>
  );
}
